const reducer = (state: any) => {
  return {
    ...state,
    waiting: true,
  };
};

export default reducer;
